import React, { useEffect, useRef } from "react";
import styles from "./OptionsPopup.module.css";
const OptionsPopup = ({ options, close, style }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    if (popupRef.current) {
      const rect = popupRef.current.getBoundingClientRect();
      const overflowBottom = rect.bottom > window.innerHeight;

      if (overflowBottom) {
        popupRef.current.style.top = `${parseInt(style.top) - rect.height}px`;
      }
    }
  }, [style]);

  return (
    <>
      <div
        className={styles.bg}
        onClick={(e) => {
          e.stopPropagation();
          close(null);
        }}
      ></div>
      <div ref={popupRef} className={styles.OptionsPopupContainer} style={style}>
        {options.map((option, index) => (
          <div
            key={index}
            onClick={option.onClick}
            className={option.askAi && styles.askAi}
          >
            {option.label}
          </div>
        ))}
      </div>
    </>
  );
};

export default OptionsPopup;
